import { all } from 'redux-saga/effects';
import authSaga from './authSaga';
import signautre from './signatureSagas'
export default function* rootSaga() {
  yield all([authSaga(),signautre()]);
}
